import dayjs from "dayjs";
import {
  describeWithdrawalWindow,
  isRequestedWithinWithdrawalWindow,
  STUDENTS_TEAM_EMAIL,
} from "./withdrawalWindow.ts";

type Props = {
  requestedAtUtc: Date;
  withdrawalDeadlineUtc: string;
};

export function WithdrawalWindowNotice({
  requestedAtUtc,
  withdrawalDeadlineUtc,
}: Props) {
  const isWithinWithdrawalWindow = isRequestedWithinWithdrawalWindow(
    requestedAtUtc,
    withdrawalDeadlineUtc,
  );

  return (
    <div
      className={`text-sm rounded-lg p-3 border ${
        isWithinWithdrawalWindow
          ? "text-green-800 bg-green-50 border-green-200"
          : "text-orange-700 bg-orange-50 border-orange-200"
      }`}
    >
      <p className="font-medium">
        Tipologia: {describeWithdrawalWindow(isWithinWithdrawalWindow)}
      </p>
      <p>
        Termine per il recesso:{" "}
        {dayjs(withdrawalDeadlineUtc).format("DD/MM/YYYY")}.{" "}
        {isWithinWithdrawalWindow
          ? "La notifica verrà inviata al closer della trattativa e al suo team leader."
          : `La notifica verrà inviata a ${STUDENTS_TEAM_EMAIL}.`}
      </p>
    </div>
  );
}
